// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../../services/types.tsx';

export const addMountedSpotlight =
	(spotlightId: string): Action<State> =>
	({ setState, getState }) => {
		if (getState().mountedSpotlightIds?.includes(spotlightId)) {
			return;
		}

		setState({ mountedSpotlightIds: [...(getState().mountedSpotlightIds || []), spotlightId] });
	};
